import { logWrapper } from '../utils';

function dragItemDirectiveFactory(runtimeConstant) {
  function link(scope, element) {
    // Define o elemento como "draggable"
    element.attr('draggable', true);

    // Cria uma imagem de arraste personalizada (canvas com borda preta)
    const canvas = document.createElement('canvas');
    canvas.width = 240;
    canvas.height = 70;

    const ctx = canvas.getContext('2d');
    ctx.strokeStyle = 'black';
    ctx.lineWidth = 2;
    ctx.strokeRect(0, 0, canvas.width, canvas.height);

    const img = new Image();
    img.src = canvas.toDataURL();

    // Define a imagem de arraste no evento de dragstart
    element.on('dragstart', (event) => {
      const dt = event.originalEvent?.dataTransfer;
      if (dt) {
        dt.setDragImage(img, 0, 0);
      }
    });
  }

  function run() {
    return {
      restrict: 'A',
      link,
    };
  }

  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const dragItemDirective = ['runtimeConstant', dragItemDirectiveFactory];
